export default __webpack_public_path__ + "static/media/andes_a_la_costa_1.727273e7.JPG";